import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { windowForRouter } from "../shared/phone/history";
import { App } from "./App";
import { AuthProvider } from "./context/AuthContext";
import { followAppearance } from "./lib/appearance";
import "./styles/suite.css";
import "./styles/index.css";
import "./styles/edit.css";
import "../shared/phone/phone.css";
import "./styles/phone.css";
import "./styles/phone-home.css";
import "./styles/phone-goal.css";
import "./styles/phone-setup.css";
import "./styles/phone-ads.css";
import "./styles/phone-products.css";
import "./styles/phone-partners.css";
import "./styles/phone-more.css";
import "./styles/phone-library.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root not found");

followAppearance();
createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter window={windowForRouter()}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
